import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isNumber, isString } from 'vega-util';
import { isMinMaxOp } from '../../aggregate';
import { getMainRangeChannel } from '../../channel';
import { isNumberFieldDef, isScaleFieldDef, isTimeFormatFieldDef, isTypedFieldDef } from '../../channeldef';
import { isGenerator } from '../../data';
import { isDateTime } from '../../datetime';
import * as log from '../../log';
import { forEachLeaf } from '../../logical';
import { isFieldEqualPredicate, isFieldOneOfPredicate, isFieldPredicate, isFieldRangePredicate } from '../../predicate';
import { isSortField } from '../../sort';
import { accessPathDepth, accessPathWithDatum, duplicate, hash as _hash, keys, removePathFromField } from '../../util';
import { isFacetModel, isUnitModel } from '../model';
import { Split } from '../split';
import { DataFlowNode } from './dataflow';
/**
 * Remove quotes from a string.
 */

function unquote(pattern) {
  if (pattern[0] === "'" && pattern[pattern.length - 1] === "'" || pattern[0] === '"' && pattern[pattern.length - 1] === '"') {
    return pattern.slice(1, -1);
  }

  return pattern;
}
/**
 * @param field The field.
 * @param parse What to parse the field as.
 */


function parseExpression(field, parse) {
  var f = accessPathWithDatum(field);

  if (parse === 'number') {
    return "toNumber(".concat(f, ")");
  } else if (parse === 'boolean') {
    return "toBoolean(".concat(f, ")");
  } else if (parse === 'string') {
    return "toString(".concat(f, ")");
  } else if (parse === 'date') {
    return "toDate(".concat(f, ")");
  } else if (parse === 'flatten') {
    return f;
  } else if (parse.indexOf('date:') === 0) {
    var specifier = unquote(parse.slice(5, parse.length));
    return "timeParse(".concat(f, ",'").concat(specifier, "')");
  } else if (parse.indexOf('utc:') === 0) {
    var _specifier = unquote(parse.slice(4, parse.length));

    return "utcParse(".concat(f, ",'").concat(_specifier, "')");
  } else {
    log.warn(log.message.unrecognizedParse(parse));
    return null;
  }
}

export var ParseNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(ParseNode, _DataFlowNode);

  _createClass(ParseNode, [{
    key: "clone",
    value: function clone() {
      return new ParseNode(null, duplicate(this._parse));
    }
  }]);

  function ParseNode(parent, parse) {
    var _this;

    _classCallCheck(this, ParseNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParseNode).call(this, parent));
    _this._parse = parse;
    return _this;
  }

  _createClass(ParseNode, [{
    key: "hash",
    value: function hash() {
      return "Parse ".concat(_hash(this._parse));
    }
    /**
     * Creates a parse node from a data.format.parse and updates ancestorParse.
     */

  }, {
    key: "merge",
    value: function merge(other) {
      this._parse = Object.assign({}, this._parse, other.parse);
      other.remove();
    }
    /**
     * Assemble an object for Vega's format.parse property.
     */

  }, {
    key: "assembleFormatParse",
    value: function assembleFormatParse() {
      var formatParse = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys(this._parse)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;
          var p = this._parse[field];

          if (accessPathDepth(field) === 1) {
            formatParse[field] = p;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formatParse;
    } // format parse depends and produces all fields in its parse

  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(keys(this._parse));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(keys(this._parse));
    }
  }, {
    key: "assembleTransforms",
    value: function assembleTransforms() {
      var _this2 = this;

      var onlyNested = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return keys(this._parse).filter(function (field) {
        return onlyNested ? accessPathDepth(field) > 1 : true;
      }).map(function (field) {
        var expr = parseExpression(field, _this2._parse[field]);

        if (!expr) {
          return null;
        }

        var formula = {
          type: 'formula',
          expr: expr,
          as: removePathFromField(field) // Vega output is always flattened

        };
        return formula;
      }).filter(function (t) {
        return t !== null;
      });
    }
  }, {
    key: "parse",
    get: function get() {
      return this._parse;
    }
  }], [{
    key: "makeExplicit",
    value: function makeExplicit(parent, model, ancestorParse) {
      // Custom parse
      var explicit = {};
      var data = model.data;

      if (!isGenerator(data) && data && data.format && data.format.parse) {
        explicit = data.format.parse;
      }

      return this.makeWithAncestors(parent, explicit, {}, ancestorParse);
    }
  }, {
    key: "makeImplicitFromFilterTransform",
    value: function makeImplicitFromFilterTransform(parent, transform, ancestorParse) {
      var parse = {};
      forEachLeaf(transform.filter, function (filter) {
        if (isFieldPredicate(filter)) {
          // Automatically add a parse node for filters with filter objects
          var val = null; // For EqualFilter, just use the equal property.
          // For RangeFilter and OneOfFilter, all array members should have
          // the same type, so we only use the first one.

          if (isFieldEqualPredicate(filter)) {
            val = filter.equal;
          } else if (isFieldRangePredicate(filter)) {
            val = filter.range[0];
          } else if (isFieldOneOfPredicate(filter)) {
            val = (filter.oneOf || filter['in'])[0];
          } // else -- for filter expression, we can't infer anything


          if (val) {
            if (isDateTime(val)) {
              parse[filter.field] = 'date';
            } else if (isNumber(val)) {
              parse[filter.field] = 'number';
            } else if (isString(val)) {
              parse[filter.field] = 'string';
            }
          }

          if (filter.timeUnit) {
            parse[filter.field] = 'date';
          }
        }
      });

      if (keys(parse).length === 0) {
        return null;
      }

      return this.makeWithAncestors(parent, {}, parse, ancestorParse);
    }
    /**
     * Creates a parse node for implicit parsing from a model and updates ancestorParse.
     */

  }, {
    key: "makeImplicitFromEncoding",
    value: function makeImplicitFromEncoding(parent, model, ancestorParse) {
      var implicit = {};

      function add(fieldDef) {
        if (isTimeFormatFieldDef(fieldDef)) {
          implicit[fieldDef.field] = 'date';
        } else if (isNumberFieldDef(fieldDef) && isMinMaxOp(fieldDef.aggregate)) {
          implicit[fieldDef.field] = 'number';
        } else if (accessPathDepth(fieldDef.field) > 1) {
          // For non-date/non-number (strings and booleans), derive a flattened field for a referenced nested field.
          // (Parsing numbers / dates already flattens numeric and temporal fields.)
          if (!(fieldDef.field in implicit)) {
            implicit[fieldDef.field] = 'flatten';
          }
        } else if (isScaleFieldDef(fieldDef) && isSortField(fieldDef.sort) && accessPathDepth(fieldDef.sort.field) > 1) {
          // Flatten fields that we sort by but that are not otherwise flattened.
          if (!(fieldDef.sort.field in implicit)) {
            implicit[fieldDef.sort.field] = 'flatten';
          }
        }
      }

      if (isUnitModel(model) || isFacetModel(model)) {
        // Parse encoded fields
        model.forEachFieldDef(function (fieldDef, channel) {
          if (isTypedFieldDef(fieldDef)) {
            add(fieldDef);
          } else {
            var mainChannel = getMainRangeChannel(channel);

            if (mainChannel !== channel) {
              var mainFieldDef = model.fieldDef(mainChannel);
              add(Object.assign({}, fieldDef, {
                type: mainFieldDef.type
              }));
            } else {
              throw new Error("Non-secondary channel ".concat(channel, " must have type in its field definition ").concat(JSON.stringify(fieldDef)));
            }
          }
        });
      }

      return this.makeWithAncestors(parent, {}, implicit, ancestorParse);
    }
    /**
     * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
     */

  }, {
    key: "makeWithAncestors",
    value: function makeWithAncestors(parent, explicit, implicit, ancestorParse) {
      // We should not parse what has already been parsed in a parent (explicitly or implicitly) or what has been derived (maked as "derived"). We also don't need to flatten a field that has already been parsed.
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keys(implicit)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var field = _step2.value;
          var parsedAs = ancestorParse.getWithExplicit(field);

          if (parsedAs.value !== undefined) {
            // We always ignore derived fields even if they are implicitly defined because we expect users to create the right types.
            if (parsedAs.explicit || parsedAs.value === implicit[field] || parsedAs.value === 'derived' || implicit[field] === 'flatten') {
              delete implicit[field];
            } else {
              log.warn(log.message.differentParse(field, implicit[field], parsedAs.value));
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = keys(explicit)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _field = _step3.value;

          var _parsedAs = ancestorParse.get(_field);

          if (_parsedAs !== undefined) {
            // Don't parse a field again if it has been parsed with the same type already.
            if (_parsedAs === explicit[_field]) {
              delete explicit[_field];
            } else {
              log.warn(log.message.differentParse(_field, explicit[_field], _parsedAs));
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var parse = new Split(explicit, implicit); // add the format parse from this model so that children don't parse the same field again

      ancestorParse.copyAll(parse); // copy only non-null parses

      var p = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = keys(parse.combine())[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var key = _step4.value;
          var val = parse.get(key);

          if (val !== null) {
            p[key] = val;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (keys(p).length === 0 || ancestorParse.parseNothing) {
        return null;
      }

      return new ParseNode(parent, p);
    }
  }]);

  return ParseNode;
}(DataFlowNode);